import React from 'react';
import { Box, Typography, Grid, Button, Card, CardContent, CardMedia, Container, Paper } from '@mui/material';
import { useLanguage } from '../i18n/LanguageContext';
import { motion } from 'framer-motion';
import SpaIcon from '@mui/icons-material/Spa';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import SelfImprovementIcon from '@mui/icons-material/SelfImprovement';
import EmojiNatureIcon from '@mui/icons-material/EmojiNature';

import homepage from "../imaged/ee82e2471a176030a77142bd075a47e2.jpg";
import personalCareImg from "../imaged/personal care.jpg";
import herbalLifeImg from "../imaged/herbal life.jpg";
import productImg1 from "../imaged/pr1.jpg";
import productImg2 from "../imaged/pr2.jpg";
import productImg3 from "../imaged/pr3.jpg";

const MotionBox = motion(Box);

const Home = () => {
  const { t } = useLanguage();

  

  return (
    <Box sx={{ overflowX: "hidden" }}>
      {/* Hero Section */}
      <Box
        sx={{
          position: "relative",
          minHeight: { xs: "60vh", md: "80vh" },
          width: "100%",     // Full width
          display: "flex",
          alignItems: { xs: "flex-start", md: "flex-start" },
          pt: { xs: 7, md: 10 },
          backgroundImage: `url(${homepage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          "&::before": { // Dark overlay for text readability
            content: '""',
            position: "absolute",
            top: 0, left: 0, right: 0, bottom: 0,
            background: "linear-gradient(to right, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.5) 100%)"
          }
        }}
      >
        <Container maxWidth="lg" sx={{ position: "relative", zIndex: 2 }}>
          <MotionBox
            initial={{ x: -50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.8 }}
            sx={{ maxWidth: 800, position: "relative", zIndex: 3 }}
          >
            <Typography
              variant="h1"
              sx={{
                mt: { xs: 0.5, md: 2 },
                color: "#ffffff",
                textShadow: "0 2px 14px rgba(0,0,0,0.9), 0 0 1px rgba(0,0,0,0.9)",
                fontWeight: 800,
                fontSize: { xs: "1.7rem", sm: "2.8rem", md: "3.2rem" },
                lineHeight: 1.1,
                display: "inline-block",
                px: { xs: 1.2, md: 1.4 },
                py: { xs: 0.4, md: 0.5 },
                borderRadius: 1,
                backgroundColor: { xs: "rgba(0,0,0,0.85)", md: "rgba(0,0,0,0.45)" },
                border: "1px solid rgba(255,255,255,0.25)",
                backdropFilter: "blur(2px)",
                maxWidth: 900,
                overflowWrap: "anywhere",
                wordBreak: "break-word"
              }}
            >
              {t("home.title")}
            </Typography>
            <Typography
              variant="h3"
              sx={{
                mt: { xs: 1, md: 3 },
                color: "#ffffff",
                textShadow: "0 2px 14px rgba(0,0,0,0.9), 0 0 1px rgba(0,0,0,0.9)",
                fontWeight: 900,
                fontSize: { xs: "0.8rem", sm: "1.2rem", md: "1.8rem" },
                lineHeight: { xs: 1.35, md: 1.3 },
                display: "inline-block",
                px: { xs: 1.2, md: 1.6 },
                py: { xs: 0.5, md: 0.6 },
                borderRadius: 1,
                backgroundColor: { xs: "rgba(0,0,0,0.85)", md: "rgba(0,0,0,0.45)" },
                border: "1px solid rgba(255,255,255,0.25)",
                backdropFilter: "blur(2px)",
                maxWidth: 900,
                overflowWrap: "anywhere",
                wordBreak: "break-word"
              }}
            >
              {t("home.subtitle")}
            </Typography>
            {/* <Typography
              variant="h6"
              sx={{
                mt: 2,
                color: "#ffffff",
                textShadow: "0 2px 14px rgba(0,0,0,0.9), 0 0 1px rgba(0,0,0,0.9)",
                lineHeight: 1.8,
                fontWeight: 400,
                fontSize: { xs: "1.1rem", md: "1.3rem" },
                maxWidth: 900,
                display: "inline-block",
                px: { xs: 1.6, md: 2 },
                py: { xs: 0.8, md: 1 },
                borderRadius: 2,
                backgroundColor: { xs: "rgba(0,0,0,0.9)", md: "rgba(0,0,0,0.55)" },
                border: "1px solid rgba(255,255,255,0.25)",
                boxShadow: "0 10px 28px rgba(0,0,0,0.45)",
                backdropFilter: "blur(2px)",
                position: "relative",
                zIndex: 4,
                overflowWrap: "anywhere",
                wordBreak: "break-word"
              }}
            >
              {t("home.subtitleDescription")}
            </Typography> */}
            <Button 
              href="/products" 
              variant="contained" 
              color="primary" 
              size="medium"
              sx={{ mt: 2, px: 3, py: 0.8, borderRadius: 50, fontSize: "0.95rem", fontWeight: 700 }}
            >
              {t("home.cta")}
            </Button>
          </MotionBox>
        </Container>
      </Box>

      {/* Products ticker */}
      <Box sx={{ bgcolor: 'grey.100', py: 2, overflow: 'hidden' }}>
        <Box
          sx={{
            display: 'flex',
            gap: 3,
            alignItems: 'center',
            whiteSpace: 'nowrap',
            '@keyframes scrollLeft': {
              '0%': { transform: 'translateX(100%)' },
              '100%': { transform: 'translateX(-100%)' }
            },
            animation: 'scrollLeft 24s linear infinite'
          }}
        >
          {[
            { img: productImg1, name: 'TUP' },
            { img: productImg2, name: 'GAURYA' },
            { img: productImg3, name: 'CHYAWANPRASH' },
            { img: productImg1, name: 'MADHUHARI' },
            { img: productImg2, name: 'EYE DROP' },
          ].concat([
            { img: productImg1, name: 'TUP' },
            { img: productImg2, name: 'GAURYA' },
            { img: productImg3, name: 'CHYAWANPRASH' },
            { img: productImg1, name: 'MADHUHARI' },
            { img: productImg2, name: 'EYE DROP' },
          ]).map((p, i) => (
            <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mx: 1 }}>
              <Box component="img" src={p.img} alt={p.name} sx={{ width: 80, height: 80, objectFit: 'cover', borderRadius: 2, boxShadow: 1 }} />
              <Typography fontWeight={700} color="text.secondary">{p.name}</Typography>
            </Box>
          ))}
        </Box>
      </Box>

      <Container maxWidth="lg" sx={{ py: { xs: 6, md: 8 } }}>
        <Box sx={{ position: "relative", height: { xs: 600, md: 540 }, maxWidth: 980, mx: "auto" }}>
          <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: { xs: "78%", md: "72%" }, height: { xs: "78%", md: "72%" }, borderRadius: "50%", border: "2px dashed", borderColor: "divider", opacity: 0.5 }} />
          <Paper elevation={6} sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: { xs: 140, md: 160 }, height: { xs: 140, md: 160 }, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", bgcolor: "background.paper", boxShadow: '0 10px 40px rgba(0,0,0,0.12)' }}>
            <Box sx={{ textAlign: "center", color: "text.secondary" }}>
              <SelfImprovementIcon color="primary" sx={{ fontSize: { xs: 36, md: 44 } }} />
              <Typography variant="subtitle2" fontWeight={700}>{t('services.title')}</Typography>
            </Box>
          </Paper>
          {
            (() => {
              const items = [
                { icon: <SpaIcon color="primary" />, title: t("home.features.natural.title"), text: t("home.features.natural.text") },
                { icon: <VerifiedUserIcon color="primary" />, title: t("home.features.certified.title"), text: t("home.features.certified.text") },
                { icon: <SelfImprovementIcon color="primary" />, title: t("home.features.wellness.title"), text: t("home.features.wellness.text") },
                { icon: <EmojiNatureIcon color="primary" />, title: t("home.features.eco.title"), text: t("home.features.eco.text") },
              ];
              const angles = [-90, 0, 90, 180];
              const r = 35;
              return items.map((it, i) => {
                const a = (angles[i] * Math.PI) / 180;
                const left = 50 + r * Math.cos(a);
                const top = 50 + r * Math.sin(a);
                return (
                  <Paper key={i} elevation={6} sx={{ position: "absolute", left: `${left}%`, top: `${top}%`, transform: "translate(-50%, -50%)", width: { xs: 170, md: 190 }, height: { xs: 170, md: 190 }, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", textAlign: "center", px: { xs: 1.2, md: 1.6 }, py: { xs: 1, md: 1.2 }, bgcolor: "background.paper", boxShadow: '0 10px 40px rgba(0,0,0,0.12)', overflow: "hidden" }}>
                    <Box sx={{ width: { xs: 58, md: 64 }, height: { xs: 58, md: 64 }, borderRadius: "50%", bgcolor: "grey.100", display: "flex", alignItems: "center", justifyContent: "center", boxShadow: 1, mb: 1.2 }}>
                      {it.icon}
                    </Box>
                    <Typography sx={{ fontWeight: 800, fontSize: { xs: "0.85rem", md: "0.95rem" }, px: 1, lineHeight: 1.3, maxWidth: "85%" }}>
                      {it.title}
                    </Typography>
                    <Typography color="text.secondary" sx={{
                      px: 1,
                      mt: 0.4,
                      fontSize: { xs: "0.72rem", md: "0.78rem" },
                      lineHeight: 1.35,
                      maxWidth: "85%",
                      display: "-webkit-box",
                      WebkitLineClamp: { xs: 3, md: 3 },
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      wordBreak: "break-word"
                    }}>
                      {it.text}
                    </Typography>
                  </Paper>
                );
              });
            })()
          }
        </Box>
      </Container>

      <Container maxWidth="lg" sx={{ py: 10 }}>

        {/* About Strip */}
        <Box sx={{ mb: 12 }}>
          <Typography variant="overline" color="primary" fontWeight={700} letterSpacing={2}>
            {t('nav.aboutParitranam')}
          </Typography>
          <Grid container spacing={4} sx={{ mt: 1 }} alignItems="stretch">
            {/* Personal Care */}
            <Grid item xs={12} md={6}>
              <MotionBox
                initial={{ y: 50, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
                sx={{ height: "100%" }}
              >
                <Card sx={{ 
                  height: '100%', 
                  borderRadius: 4,
                  overflow: 'hidden',
                  position: 'relative',
                  transition: "transform 0.3s ease",
                  "&:hover": { transform: "translateY(-10px)" },
                  boxShadow: '0 10px 40px rgba(0,0,0,0.1)'
                }}>
                  <Box sx={{ position: "relative", height: 300 }}>
                     <CardMedia
                      component="img"
                      height="100%"
                      image={personalCareImg}
                      alt="Personal Care"
                      sx={{ objectFit: 'cover' }}
                    />
                    <Box sx={{
                      position: "absolute",
                      bottom: 0, left: 0, right: 0,
                      height: "50%",
                      background: "linear-gradient(to top, rgba(0,0,0,0.8), transparent)"
                    }} />
                    <Typography variant="h4" sx={{ 
                      position: "absolute", 
                      bottom: 24, 
                      left: 24, 
                      color: "white", 
                      fontWeight: 700 
                    }}>
                      {t('home.cards.1.title')}
                    </Typography>
                  </Box>
                  <CardContent sx={{ p: 4 }}>
                    <Typography variant="body1" sx={{ color: 'text.secondary', lineHeight: 1.8, fontSize: '1.1rem' }}>
                      {t('home.cards.1.text')}
                    </Typography>
                  </CardContent>
                </Card>
              </MotionBox>
            </Grid>

            {/* Herbal Life */}
            <Grid item xs={12} md={6}>
              <MotionBox
                initial={{ y: 50, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.8, delay: 0.2 }}
                viewport={{ once: true }}
                sx={{ height: "100%" }}
              >
                <Card sx={{ 
                  height: '100%', 
                  borderRadius: 4,
                  overflow: 'hidden',
                  position: 'relative',
                  transition: "transform 0.3s ease",
                  "&:hover": { transform: "translateY(-10px)" },
                  boxShadow: '0 10px 40px rgba(0,0,0,0.1)'
                }}>
                  <Box sx={{ position: "relative", height: 300 }}>
                     <CardMedia
                      component="img"
                      height="100%"
                      image={herbalLifeImg}
                      alt="Herbal Life"
                      sx={{ objectFit: 'cover' }}
                    />
                    <Box sx={{
                      position: "absolute",
                      bottom: 0, left: 0, right: 0,
                      height: "50%",
                      background: "linear-gradient(to top, rgba(0,0,0,0.8), transparent)"
                    }} />
                    <Typography variant="h4" sx={{ 
                      position: "absolute", 
                      bottom: 24, 
                      left: 24, 
                      color: "white", 
                      fontWeight: 700 
                    }}>
                      {t('home.cards.2.title')}
                    </Typography>
                  </Box>
                  <CardContent sx={{ p: 4 }}>
                    <Typography variant="body1" sx={{ color: 'text.secondary', lineHeight: 1.8, fontSize: '1.1rem' }}>
                      {t('home.cards.2.text')}
                    </Typography>
                  </CardContent>
                </Card>
              </MotionBox>
            </Grid>
          </Grid>
        </Box>

        {/* Highlight Product/Pack */}
        <Box sx={{ textAlign: "center" }}>
          <Typography variant="overline" color="primary" fontWeight={700} letterSpacing={2}>
            {t('products.title')}
          </Typography>
          <Typography variant="h2" fontWeight={800} sx={{ mb: 6, mt: 1 }}>
            {t('home.featuredCollections')}
          </Typography>

          {/* Images Row */}
          <Grid container spacing={4} justifyContent="center">
            {[productImg1, productImg2, productImg3].map((img, i) => (
              <Grid item xs={12} sm={4} key={i}>
                <MotionBox
                  initial={{ y: 30, opacity: 0 }}
                  whileInView={{ y: 0, opacity: 1 }}
                  transition={{ duration: 0.8, delay: i * 0.2 }}
                  viewport={{ once: true }}
                >
                  <Box
                    component="img"
                    src={img}
                    alt={`Product ${i + 1}`}
                    sx={{
                      width: "100%",
                      height: 350,
                      objectFit: "cover",
                      borderRadius: 4,
                      boxShadow: '0 8px 30px rgba(0,0,0,0.1)',
                      transition: "transform 0.3s ease",
                      "&:hover": { transform: "scale(1.03)" }
                    }}
                  />
                </MotionBox>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default Home;
